﻿angular.module('projectModule')
    .controller('MeasureRcController',
        ['$scope', '$controller', '$routeParams', 'ntaValidation', 'ntaMeasure',
function ($scope,   $controller,   $routeParams,   ntaValidation,   ntaMeasure) {
    'use strict';
    const ctrl = this;
    const base = $controller('NTABaseController', { $scope: $scope })
    angular.extend(ctrl, base);

    //== Imports ==================================================================================
    ctrl.ntaValidation = ntaValidation;


    //== Instance data ============================================================================
    const logic = ntaMeasure.getLogic($routeParams.shadowId);

    const _subtitleByPropId = new Map(Object.entries({
        'MEASURE-RC_LIBCONSTR_ID': 'Vervang R<sub>c</sub> van constructie',
        'MEASURE-RC_BEGR_IDS': 'Vervang R<sub>c</sub> van constructies met de volgende kenmerken',
        'MEASURE-RC_RC': 'Nieuwe R<sub>c</sub> van constructie(s)',
        'MEASURE-RC_KOSTEN_INV': 'Kosten',
        'MEASURE-RC_SUBS_INV': 'Subsidie',
    }));


    //== Exports ==================================================================================
    ctrl.logic = logic;
    ctrl.properties = logic.properties;
    ctrl.entdata = logic.entdataMeasureRc;
    ctrl.measureType = logic.measureType;
    ctrl.isReadOnly = logic.isReadOnly;
    ctrl.isHidden = logic.isHidden;
    ctrl.getCodedValues = logic.getCodedValues;
    ctrl.isItemChecked = logic.isItemChecked;
    ctrl.toggleItemChecked = logic.toggleItemChecked;
    ctrl.onValidateCallback = logic.onValidateCallback;

    ctrl.getForm = () => logic.form;
    ctrl.getPropData = prop => base.getPropData(prop, logic.entdataMeasureRc);
    ctrl.getPropertyType = prop => prop && prop.PropertyType;

    Object.assign(ctrl, {
        getSubtitle,
        saveValue,
    });

    $scope.endFormValidation = logic.endFormValidation;


    //== Initialization ===========================================================================

    ntaMeasure.setBtwPropIds(ctrl);

    angular.element(function () { //alle touched properties valideren na het laden van form
        logic.startFormValidation();
        logic.setGeopend();
    });

    //== Implementation ===========================================================================

    function getSubtitle(prop) {
        return _subtitleByPropId.get(prop.Id) || '';
    } //-- end: getSubtitle -----------------------------------------------------------------------

    function saveValue(prop) {
        logic.saveValue(prop, logic.entdataMeasureRc);
        base.initializeUnitSpacing();
    } //-- end: saveValue -------------------------------------------------------------------------

}]);
